// Class: motion.actuators.IGenericActuator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var IGenericActuator = function() {}

// Meta

IGenericActuator.__name__ = ["motion","actuators","IGenericActuator"];
IGenericActuator.__isInterface__ = true;
IGenericActuator.prototype = {
	
};
IGenericActuator.prototype.__class__ = IGenericActuator.prototype.constructor = $hxClasses["motion.actuators.IGenericActuator"] = IGenericActuator;

// Init



// Statics




// Export

exports.default = IGenericActuator;